/**
 * Modal.js
 */
import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import MotifModal from '@ey/canvascoreservices/Modal';
import {setIsModalOpen, setModalLevel} from '../../../actions/Task/setIsModalOpen';
import {setFormV2ToasterVisibility} from '../../../actions/Toast/toastactions';
import {clearErrors} from '../../../actions/erroractions';
import ModalErrors from '../Errors/ModalErrors';

export default function Modal(props) {
	const {
		show,
		onHide,
		onOkClick,
		onSaveCreateClick,
		title,
		children,
		isOkButtonDisabled,
		isCancelButtonDisabled,
		isSaveCreateButtonDisabled,
		showButtons,
		hideCloseButton,
		hideConfirmButton,
		hideCancelButton,
		confirmBtnTitle,
		confirmBtnToolTip,
		closeBtnTitle,
		saveCreateBtnTitle,
		saveCreateBtnToolTip,
		closeTitle,
		modalsize,
		modalbodystyle,
		modalContainerClass,
		modalonmodal,
		disableClose,
		okTitle,
		footerInfo,
		bodyminheight,
		role,
		tooltipLabel = null,
		tootilPosition,
		footerError,
		focusTrapOptions,
		variant,
		confirmBtnVariant,
		className,
		takeover,
		size,
		showFooter,
		customFooter,
		focusTrapActive
	} = props;

	const isSizeDefined = size || false;
	const dispatch = useDispatch();
	const isModalMounted = useRef(false);
	const modalLevel = useSelector((store) => store.modalLevel);
	const modalVal = useRef(modalLevel);

	const resetModalLevel = () => {
		modalVal.current = modalVal.current > 0 ? modalVal.current - 1 : 0;
		dispatch(setModalLevel(modalVal.current));
		modalVal.current === 0 && dispatch(setIsModalOpen(false));
		dispatch(setFormV2ToasterVisibility(false));
		dispatch(clearErrors());
		isModalMounted.current = false;
	};

	const handleOnClose = () => {
		onHide && onHide();
	};

	const handleOnOkClick = () => {
		onOkClick && onOkClick();
	};

	useEffect(() => {
		if (show) {
			isModalMounted.current = true;
			modalVal.current = modalVal.current + 1;
			dispatch(setIsModalOpen(true));
			dispatch(setModalLevel(modalVal.current));
		}
		return () => {
			isModalMounted.current && resetModalLevel();
		};
	}, [show]);

	return (
		<MotifModal
			show={show}
			onClose={handleOnClose}
			className={`${className}  ${modalsize} ${modalContainerClass} ${isSizeDefined ? 'motif-size' : ''}`}
			takeover={takeover}
			size={size}
			modalsize={modalsize}
			onOkClick={handleOnOkClick}
			onSaveCreateClick={onSaveCreateClick}
			title={title}
			isOkDisabled={isOkButtonDisabled}
			isCancelDisabled={isCancelButtonDisabled}
			isMiddleButtonDisabled={isSaveCreateButtonDisabled}
			isSaveCreateButtonDisabled={isSaveCreateButtonDisabled}
			showButtons={showButtons}
			hideCloseButton={hideCloseButton}
			hideConfirmButton={hideConfirmButton}
			hideCancelButton={hideCancelButton}
			hideMiddleButton={!saveCreateBtnTitle}
			onMiddleButtonClick={onSaveCreateClick}
			confirmBtnTitle={confirmBtnTitle}
			confirmBtnToolTip={confirmBtnToolTip}
			closeBtnTitle={closeBtnTitle}
			middleButtonTitle={saveCreateBtnTitle}
			saveCreateBtnToolTip={saveCreateBtnToolTip}
			closeTitle={closeTitle}
			modalbodystyle={modalbodystyle}
			modalContainerClass={modalContainerClass}
			modalonmodal={modalonmodal}
			disableClose={disableClose}
			footerInfo={footerInfo}
			bodyminheight={bodyminheight}
			role={role}
			tooltipLabel={tooltipLabel}
			tootilPosition={tootilPosition}
			footerError={footerError}
			focusTrapOptions={focusTrapOptions}
			variant={variant}
			confirmBtnVariant={confirmBtnVariant}
			showFooter={showFooter || showButtons}
			customFooter={customFooter}
			focusTrapActive={focusTrapActive}
		>
			<ModalErrors modalLevel={modalVal.current} />
			{children}
		</MotifModal>
	);
}

Modal.propTypes = {
	children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	modalsize: PropTypes.string,
	confirmBtnTitle: PropTypes.string,
	confirmBtnToolTip: PropTypes.string,
	closeBtnTitle: PropTypes.string,
	saveCreateBtnTitle: PropTypes.string,
	saveCreateBtnToolTip: PropTypes.string,
	modalbodystyle: PropTypes.string,
	modalContainerClass: PropTypes.string,
	showButtons: PropTypes.bool,
	hideCloseButton: PropTypes.bool,
	hideConfirmButton: PropTypes.bool,
	hideCancelButton: PropTypes.bool,
	isOkButtonDisabled: PropTypes.bool,
	isCancelButtonDisabled: PropTypes.bool,
	isSaveCreateButtonDisabled: PropTypes.bool,
	disabled: PropTypes.bool,
	show: PropTypes.bool,
	bodyminheight: PropTypes.string,
	role: PropTypes.string,
	tooltipLabel: PropTypes.string,
	tootilPosition: PropTypes.string
};

Modal.defaultProps = {
	className: 'defaultModal',
	bodyminheight: 'unset',
	confirmBtnVariant: 'primary',
	focusTrapActive: false
};
